export const APIs = {
  production: 'https://vitisysapi.azurewebsites.net/api/v1/',
  legacy: 'https://vitisysapi-legacy-cecrctcfhehdanfh.brazilsouth-01.azurewebsites.net/api/v1/',
}

export const environment = {
  production: true,
  API: localStorage.getItem('API') || APIs.production,
  siteKey: '6LePXYolAAAAAOcmL2PnCj_0hu-4glmE_KVesq7r',
};